// sponsorID exacto del kiosko dinámico de MacCenter. Solo este sponsor
// muestra el selector "iPhone / Otro dispositivo" antes del formulario.
export const MACCENTER_SPONSOR_ID = "MACCENTER";

export type DeviceKind = "phone" | "appliance";

// MacCenter solo vende Apple: en "otro dispositivo" el fabricante queda fijo
// (no editable) y la categoría se limita a estos idSystem de
// GET /appliances/categories (se excluyen TELEFONO_MOVIL —va por el flujo de
// iPhone— y las líneas blancas que no vende: TV, LAVADORA, REFRIGERADOR,
// MICROONDAS).
export const APPLIANCE_MANUFACTURER = "Apple";
export const ALLOWED_APPLIANCE_CATEGORY_IDS = [
  "LAPTOP",
  "SMARTWATCH",
  "TABLET",
];

// GET .../appliances/policy/free devuelve TODOS los planes del sponsor (no
// trae categoría/idSystem por plan para filtrar por endpoint), así que el
// filtro por categoría se hace en el front por el nombre del plan
// ("Plan 1 Apple Watch" / "Plan 1 iPad" / "Plan 1 Mac").
export const APPLIANCE_CATEGORY_PLAN_KEYWORDS: Record<string, string[]> = {
  SMARTWATCH: ["watch"],
  TABLET: ["ipad", "tablet"],
  LAPTOP: ["mac", "macbook", "laptop"],
};

// Solo cambia lo que ve el agente en el dropdown de categoría — el request
// sigue mandando el `idSystem` real (TABLET/LAPTOP/SMARTWATCH) sin tocar.
export const APPLIANCE_CATEGORY_DISPLAY_LABELS: Record<string, string> = {
  TABLET: "iPad",
  LAPTOP: "Mac",
  SMARTWATCH: "Apple Watch",
};
